import { Report } from "../types";
import { getProductionRatio, hasRatioField, sumOf } from "../utils";

export const validateTotal = (params: Report[]) => {
  const ratioFields = [
    "ratio-tier-3-yarn",
    "ratio-tier-2-fabric-nonWoven",
    "ratio-tier-2-fabric-lace",
    "ratio-tier-2-fabric-membranes",
    "ratio-tier-2-fabric-knitting",
    "ratio-tier-2-fabric-weaving",
    "ratio-tier-2-fabric-general",
    "ratio-tier-2-further",
    "ratio-tier-1-garment",
    "ratio-tier-1-accessories",
    "ratio-tier-leather-leather",
    "ratio-tier-footwear-footwear",
    "ratio__garment",
    "ratio__yarn",
    "ratio__leather",
    "ratio__further",
    "ratio__accessories",
    "ratio__footwear",
    "ratio__fabric-general",
    "ratio__fabric-knitting",
    "ratio__fabric-weaving",
    "ratio__fabric-membranes",
    "ratio__fabric-lace",
    "ratio__fabric-nonWoven",
  ];

  if (params && params.length > 0 && hasRatioField(params[0], ratioFields)) {
    return getProductionRatio(params);
  }

  return sumOf(params, [
    "total-fiber-types",
    "total-dyeing",
    "total-bags",
    "total-spinning",
    "total-fabric-compositions",
    "total-wet-processes",
    "total-garment-types",
    "total-production-range",
    "total-dyeing-types",
    "total-tanning-methods",
    "product-type-total-production-range",
    "customer-type-total-production-range",
    "knitting-type-total-production-range",
    "fabric-knitting-material-total-production-range",
    "fabric-weaving-machine-type-total-production-range",
    "fabric-weaving-product-type-total-production-range",
    "fabric-weaving-weaving-type-total-production-range",
    "fabric-weaving-material-type-total-production-range",
    "yarn-spinning-spinning-type-total-production-range",
    "yarn-spinning-sub-type-total-production-range",
    "yarn-spinning-material-type-total-production-range",
    "crp-ext-garment-finishing-and-wet-processes-fabric-type-in-percent-print-only",
    "crp-ext-garment-finishing-and-wet-processes-fibre-blend-processed-in-percent-print-only",
    "crp-ext-garment-finishing-and-wet-processes-process-description-in-percent-print-only",
    "crp-ext-bm-fabric-dyeing-fabric-type-in-percent-total-dyeing-types",
    "crp-ext-bm-fabric-dyeing-fibre-blend-processed-in-percent-total-dyeing-types",
    "crp-ext-bm-fabric-dyeing-fibre-process-description-in-percent-total-dyeing-types",
    "crp-ext-bm-fabric-dyeing-fibre-dye-type-in-percent-total-dyeing-types",
    "crp-ext-bm-garment-substrate-type-processed-in-percent-total-dyeing-types",
    "crp-ext-bm-garment-fibre-blend-processed-in-percent-total-dyeing-types",
    "crp-ext-bm-garment-dye-type-in-percent-total-dyeing-types",
    "crp-ext-bm-washing-and-finishing-process-type-in-percent-print-only",
    "crp-ext-bm-washing-and-finishing-fabric-type-in-percent-print-only",
    "crp-ext-bm-washing-and-finishing-fibre-blend-processed-in-percent-print-only",
    "crp-ext-bm-washing-and-finishing-process-group-in-percent-print-only",
    "crp-ext-bm-washing-and-finishing-process-description-in-percent-print-only",
    "crp-ext-bm-yarn-fiber-substrate-type-total-dyeing",
    "crp-ext-bm-yarn-fiber-fabric-type-total-dyeing",
    "crp-ext-bm-yarn-fibre-blend-processed-dyeing-type",
    "crp-ext-bm-fabric-dyeing-only-without-fabric-type-in-percent-total-dyeing-types",
    "crp-ext-bm-fabric-dyeing-only-without-fibre-blend-processed-in-percent-total-dyeing-types",
    "crp-ext-bm-fabric-dyeing-only-without-fibre-procces-group-in-percent-total-dyeing-types",
    "crp-ext-bm-fabric-dyeing-only-without-fibre-dye-type-in-percent-total-dyeing-types",
    "crp-ext-bm-garments-dyeing-only-without-fibre-fabric-type-in-percent-total-dyeing-types",
    "crp-ext-bm-garments-dyeing-only-without-fibre-blend-processed-in-percent-total-dyeing-types",
    "crp-ext-bm-garments-dyeing-only-without-fibre-dye-type-in-percent-total-dyeing-types",
    "crp-ext-bm-fabric-printing-fabric-type-in-percent-print-only",
    "crp-ext-bm-fabric-printing-fibre-blend-processed-in-percent-print-only",
    "crp-ext-bm-fabric-printing-process-group-in-percent-print-only",
    "crp-ext-bm-fabric-printing-process-process-description-in-percent-print-only",
    "crp-ext-bm-fabric-printing-process-dye-type-in-percent-print-only",
    "crp-ext-bm-garment-panel-printing-fibre-blend-processed-in-percent-print-only",
    "crp-ext-bm-garment-panel-printing-process-group-in-percent-print-only",
    "crp-ext-bm-garment-panel-printing-process-process-description-in-percent-print-only",
    "crp-ext-bm-garment-panel-printing-process-dye-type-in-percent-print-only",
    "crp-ext-bm-tops-printing-fibre-blend-processed-in-percent-print-only",
    "crp-ext-bm-fabric-printing-full-fabric-type-in-percent-print-only",
    "crp-ext-bm-fabric-printing-full-fibre-blend-processed-in-percent-print-only",
    "crp-ext-bm-fabric-printing-full-process-group-in-percent-print-only",
    "crp-ext-bm-fabric-printing-full-process-process-description-in-percent-print-only",
    "crp-ext-bm-fabric-printing-full-process-dye-type-in-percent-print-only",
    "crp-ext-bm-fabric-washing-and-finishing-process-type-in-percent-print-only",
    "crp-ext-bm-fabric-washing-and-finishing-pre-treatment-process-type-in-percent-print-only",
    "crp-ext-bm-washing-and-finishing-pre-treatment-type-in-factory-in-percent-print-only",
    "crp-ext-bm-washing-and-finishing-pre-treatment-process-description-in-percent-print-only",
    "gauge-total-production-range",
  ]);
};
